import { useEffect, useRef } from 'react'
import { useUpdate } from 'ahooks'

interface IParams {
    onSend?: ()=> void,
    root: ()=> HTMLElement,
}

export default ({
  onSend,
  root,
}:IParams) => {
  const flagRef = useRef(false)
  const positionY = useRef(0)
  const onUpdate = useUpdate()
  const $dom = root()
  useEffect(() => {
    flagRef.current = false
    const onScroll = () => {
      if (!$dom) {
        positionY.current = 0
        onUpdate()
        return
      }
      const _positionY = $dom.getBoundingClientRect().y
      if (_positionY <= 64 && _positionY >= 0) {
        flagRef.current = false
        onSend?.()
        positionY.current = 64 - _positionY
        onUpdate()
      } else if (_positionY > 64) {
        positionY.current = 0
        onUpdate()
      } else if (_positionY < 0) {
        positionY.current = 64
        onUpdate()
      }
    }
    document.body.addEventListener('scroll', onScroll)
    if (!$dom) {
      positionY.current = 0
      onUpdate()
      document.body.removeEventListener('scroll', onScroll)
    }
    return () => {
      document.body.removeEventListener('scroll', onScroll)
    }
  }, [$dom])

  return positionY
}
